








import "roboto-fontface/css/roboto/sass/roboto-fontface-regular.scss";
import "roboto-fontface/css/roboto/sass/roboto-fontface-medium.scss";
import "roboto-fontface/css/roboto/sass/roboto-fontface-bold.scss";
import { Component, Vue } from "vue-property-decorator";
import IncomeForm from "./components/IncomeForm/IncomeForm.vue";
import Result from "./components/Result/Result.vue";
import Modifiers from "./components/Modifiers/Modifiers.vue";

@Component({
  components: {
      IncomeForm,
      Result,
      Modifiers
  }
})
export default class App extends Vue {
  getMonthIncome() {
    return this.$store.state.monthIncome;
  }

  setMonthIncome(value: string) {
      this.$store.dispatch("changeMonthIncome", Number(value.replace(/[^\d]/mg, '')));
  }

  getResult () {
      return this.$store.getters.result;
  }

  getModifiers() {
      const modifiers = this.$store.state.modifiers;
      return Object.keys(modifiers).filter(key => modifiers[key] !== false);
  }

  setModifiers(value: string[]) {
      const modifiers = this.$store.state.modifiers;
      const newModifiers = Object.keys(modifiers).reduce((m, key) => {
          // @ts-ignore
          m[key] = value.includes(key);
          return m;
      }, {});

      this.$store.dispatch("changeModifiers", newModifiers);
  }
}
